export default __webpack_public_path__ + "static/media/arrow_right.cb933816.svg";